<div class="confirmation-component">
  <h4>Confirmation</h4>
  <h5><strong>Thank you for registering your Benefit Manager Toolkit Client Administrator account.</strong></h5>
  <p><strong>User Name:</strong> <span>{{ userInfo()?.userIdentifier }}</span></p>
  <p>You can now begin creating and editing Benefit Manager Toolkit account for other in organization.<br>
    To log in to the toolkit {{link}} or click below.
    For more information about how to create and edit Benefit Manager Toolkit users--including frequently asked
    questions and a video demo--log in to the Toolkit and click Help tab.</p>
  <h6>After creating a new account for a user:</h6>
  <ul>
    <li>Notify the user of their user name.</li>
    <li>Direct the user to {{link}}</li>
    <li><strong>If applicable, remind users that existing Benefit Manager Toolkit accounts will be deactivated in 30 days</strong></li>
  </ul>
  <a routerLink="/login">Click to login</a>
</div>
